import { FC, Fragment, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faPerson, faSuitcase } from '@fortawesome/free-solid-svg-icons';
import { DynamicEventResponse } from 'ts/dynamic/interfaces/DynamicResponse';
import { formatPriceCurrency, getCurrency } from 'utils/utils';
import Skeleton from 'react-loading-skeleton';
import { DynamicContext } from 'contexts/DynamicContext';
import { getDynText } from 'utils/dynamic/dynamic';
import ProposalHeart from 'components/shared/Proposal/Create/ProposalHeart';
import withErrorBoundary from 'components/shared/withErrorBoundary';
import { useDynamicProposal } from 'hooks/useDynamicProposal';
import { MainContext } from 'contexts/MainContext';

interface DynamicSummaryProps {
  data: DynamicEventResponse;
}

const DynamicSummary: FC<DynamicSummaryProps> = ({ data }) => {
  const { t } = useTranslation();
  const { numberOfPax } = useContext(DynamicContext);
  const { cdnUrl } = useContext(MainContext);
  const isTicketOnly = !!data.dynamicAttraction && !data.dynamicHotel && !data.dynamicFlight;
  const ticketCurrency = sessionStorage.getItem('searchAttractionCurrency') || 'usd';
  const { isDynamicInProposal, toggleDynamicProposal } = useDynamicProposal();

  const [choosenTicket, setChoosenTicket] = useState(
    data.dynamicAttraction?.tickets?.find(
      (tic) => tic.ticket.itemNumber === data.dynamicAttraction?.id
    )
  );

  useEffect(() => {
    setChoosenTicket(
      data.dynamicAttraction?.tickets?.find(
        (tic) => tic.ticket.itemNumber === data.dynamicAttraction?.id
      )
    );
  }, [data]);

  return (
    <div
      className={
        'default-shadow details-summary mb-20 position-relative' +
        (choosenTicket?.team1Logo ? ' details-summary-ticket-wr' : '')
      }
    >
      <div className="title-underline title-header-grey title mb-20">
        {t('dyn.package_details')}
        <ProposalHeart
          active={isDynamicInProposal(data)}
          onClickPropsal={() => toggleDynamicProposal(data)}
        />
      </div>
      {!!choosenTicket?.team1Logo && !!choosenTicket.team2Logo && (
        <div className="details-summary-ticket ">
          <img className="img-box-shadow" src={cdnUrl + choosenTicket.team1Logo} alt="1" />
          <img className="img-box-shadow" src={cdnUrl + choosenTicket.team2Logo} alt="1" />
          <div className="text-bold">{data.dynamicAttraction?.showName}</div>
        </div>
      )}
      <div className="mb-10 text-bold">{data.dynamicAttraction?.city}</div>
      {!!data.dynamicHotel && (
        <div className="mb-5 text-sm">
          <FontAwesomeIcon icon={faCalendar} className="mr-5 text-sm" />
          {data.dynamicHotel.selectedHotel?.roomClasses[0].nights} {t('hotel.nights')}
        </div>
      )}
      {!!numberOfPax && !isTicketOnly && (
        <div className="mb-5 text-sm">
          <FontAwesomeIcon icon={faPerson} className="mr-5 text-sm" />
          {numberOfPax} {t('dyn.people')}
        </div>
      )}
      <div className="mb-20 text-sm">
        <FontAwesomeIcon icon={faSuitcase} className="mr-5" />
        {getDynText(data)}
      </div>
      {!!data.packageInfo.packageTotalPrice ? (
        <Fragment>
          {!isTicketOnly && (
            <Fragment>
              <div className="text-md text-bold mb-5">
                {t('total')}:{' '}
                {formatPriceCurrency(
                  data.packageInfo.packageTotalPrice,
                  data.packageInfo.currencySymbol
                )}
              </div>
              <div className="text-sm mb-5">
                {t('flight.avarage_per_passenger')}:{' '}
                {formatPriceCurrency(
                  data.packageInfo.packageTotalPrice / numberOfPax,
                  data.packageInfo.currencySymbol
                )}
              </div>
            </Fragment>
          )}
          {isTicketOnly && (
            <Fragment>
              <div className="text-md text-bold mb-5">
                {t('total')}:{' '}
                {formatPriceCurrency(
                  (choosenTicket?.ticket.myPrice.gross as any)[ticketCurrency],
                  getCurrency(ticketCurrency)
                )}
              </div>
            </Fragment>
          )}
        </Fragment>
      ) : (
        <div>
          <Skeleton width={100}></Skeleton>
        </div>
      )}
    </div>
  );
};

export default withErrorBoundary(DynamicSummary, 'DynamicSummary');
